import React, { useState, useEffect } from 'react';
import './TermCondition.css';
import { Link } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Nav from "../../Components/Navbar/NewNavbar"
import Loading1 from '../../Components/Loading/Loading1';
const TermConditions = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);
    if (isLoading) {
        return <Loading1 />;
    }
    return (
        <>
            <Nav />
            <div className="terms-container">
                <h2>Terms and Conditions</h2>
                <p><strong>1. Introduction:</strong> <br />
                    Welcome to Astra Clean. These terms and conditions outline the rules and regulations for the use of Astra Clean's website and services.
                </p>
                <p><strong>2. Services:</strong> <br />
                    Astra Clean provides home and personal cleaning services, including but not limited to residential cleaning, commercial cleaning, and specialized cleaning services.
                </p>
                <p><strong>3. Booking and Payment:</strong> <br />
                    <strong>-Booking:</strong> All services must be booked through our website or official channels. <br />
                    <strong>-Payment:</strong> Payments must be made at the time of booking or COD. We accept various payment methods including credit/debit cards, bank transfers, and digital wallets.
                </p>
                <p><strong>4. Cancellation:</strong> <br />
                    <strong>-Cancellation:</strong> We don't provide a cancellation option since we provide services within 2 hours, but we do allow rescheduling of timing and date.
                </p>
                <p><strong>5. Satisfaction Guarantee:</strong> <br />
                    We aim to provide high-quality services. If you are not satisfied with the service, please contact us within 24 hours of service completion, and we will address your concerns.
                </p>
                <p><strong>6. Responsibilities of the Customer:</strong> <br />
                    <strong>-Access:</strong> Customers must provide access to the premises at the scheduled service time. <br />
                    <strong>-Preparation:</strong> Customers should ensure that the premises are ready for cleaning, with personal items and valuables securely stored.
                </p>
                <p><strong>7. Liability:</strong> <br />
                    Astra Clean is not liable for any damage or loss of property that occurs as a result of negligence by the cleaning staff. However, we will take reasonable steps to compensate for damages caused by our staff.
                </p>
                <p><strong>8. Privacy Policy:</strong> <br />
                    Your privacy is important to us. Please review our Privacy Policy for information on how we collect, use, and protect your personal information.
                </p>
                <p><strong>9. Changes to Terms and Conditions:</strong> <br />
                    Astra Clean reserves the right to modify these terms and conditions at any time. Changes will be effective immediately upon posting on our website.
                </p>
                <p><strong>10. Governing Law:</strong> <br />
                    These terms and conditions are governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts of Bangalore, India.
                </p>
                <p><strong>11. Contact Us:</strong> <br />
                    If you have any questions about these terms and conditions, please contact us at: <br />
                    Email: <Link to="mailto:lakshjain1218@outlook.com">lakshjain1218@outlook.com</Link> <br />
                    Phone: <Link to="tel:+916366267882">+91 63662 67882</Link> <br />
                    Address: Sarjapur, Bangalore, India
                </p>
            </div>
            <Footer />
        </>
    );
};

export default TermConditions;